<template>
    <div class="edit_pwd"  v-if="addOk">
        <el-card class="edit_pwd_account">
           <div slot="header" class="clearfix" style="text-align:center;">
                <span>修改密码</span>
            </div>
            <div class="editContent">
                <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="密码" prop="pass">
                        <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass">
                        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
                    </el-form-item>
                    <p style="color:gray;font-size: 15px;margin-left:30px;">密码长度6～16位</p>
                    <el-form-item>
                        <el-button type="primary" @click="commitEditPwd('ruleForm2')" style="width:300px;margin-top:20px;">确认修改密码</el-button>
                    </el-form-item>
              </el-form>
            </div> 
            <span @click="boxClose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
        </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'
    import md5 from 'js-md5'

    export default {
      props: ['addShow', 'linkId'],
      data () {
        var validatePass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入密码'))
          } else {
            if (this.ruleForm2.checkPass !== '') {
              this.$refs.ruleForm2.validateField('checkPass')
            }
            callback()
          }
        }
        var validatePass2 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'))
          } else if (value !== this.ruleForm2.pass) {
            callback(new Error('两次输入密码不一致!'))
          } else {
            callback()
          }
        }
        return {
          ruleForm2: {
            pass: '',
            checkPass: ''
          },
          rules2: {
            pass: [
              {validator: validatePass, trigger: 'blur'}
            ],
            checkPass: [
              {validator: validatePass2, trigger: 'blur'}
            ]
          }
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        mylinkId: function () {
          return this.linkId
        }
      },
      methods: {
        boxClose () {
          this.ruleForm2.pass = ''
          this.ruleForm2.checkPass = ''
          this.$emit('closeEditPwd', false)
        },
        commitEditPwd (formName) {
          var _this = this
          this.$refs[formName].validate((valid) => {
            if (valid) {
              var params = {
                password: md5(_this.ruleForm2.pass),
                id: _this.mylinkId
              }
              $axios.post('/custom/changePwd', params, 'headers', function (res) {
                if (res && res.resultStatus === true) {
                  _this.$message({
                    message: '修改成功',
                    type: 'success'
                  })
                  _this.boxClose()
                } else {
                }
              })
            } else {
              return false
            }
          })
        }
      }
    }
</script>
<style lang="scss">
  .edit_pwd {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;

  .edit_pwd_account {
    min-height: 330px;
    width: 500px;
    top: 20%;
    left: 50%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .editContent {
      text-align: left;
      margin-left: 0px; 

      .el-input{
        width: 300px;
      }
      .e_left {
          width: 20%;
          display: inline-block;
      }
    }
  }
    }
</style> 


// WEBPACK FOOTER //
// src/page/deviceMgr/editPoPwd.vue